import { c as _c } from "react/compiler-runtime";
import isEqual from 'lodash/isEqual';
import { inputsKeyError } from '../store/field-key';
import { useBuilder } from '../store/provider';
import type { InputField } from '../store/types';
import { inputsToWire } from '../store/wire';
export const usePersistInputs = () => {
  const $ = _c(4);
  const {
    state,
    mutateOp
  } = useBuilder();
  let t0;
  if ($[0] !== mutateOp || $[1] !== state.current?.isHistoricalPreview || $[2] !== state.savedBundle) {
    t0 = inputs => {
      if (state.current?.isHistoricalPreview || !state.savedBundle) {
        return;
      }
      if (inputsKeyError(inputs)) {
        return;
      }
      const wire = inputsToWire(inputs);
      if (isEqual(wire, inputsToWire(state.savedBundle.inputs))) {
        return;
      }
      mutateOp({
        kind: "update_inputs",
        inputs: wire
      });
    };
    $[0] = mutateOp;
    $[1] = state.current?.isHistoricalPreview;
    $[2] = state.savedBundle;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};